import { extendObservable } from "mobx";
import { MovimentoGEDTO } from "./MinutaMovimentos";

export class CategoriaMinuta {
    private static mobxInicial = () => ({
        movimentoCNJ: [],
        descricao: ''
    })

    numero: number;
    codigoMovimentoCnj: string;
    movimentoCNJ: MovimentoGEDTO[];
    descricaoMovimentoCnj?: string;
    descricao: string;
    siglaOrgaoJulgador?: string;

    //Motivo do movimento CNJ
    codigoMotivoAndamento?: string;

    public static novo(dto) {
        if (!dto) {
            dto = {};
        }
        const categoria = new CategoriaMinuta();

        const mobxInicial = CategoriaMinuta.mobxInicial();
        extendObservable(categoria, mobxInicial);

        return Object.assign(categoria, dto);
    }

    public toJSON() {
        return {
            ...this,
            descricaoMovimentoCnj: undefined
        }
    }

}

export class MinutaCategoriaEnvelope {
    categoriaDB: CategoriaMinuta;
    id: {
        numeroMinuta: number;
        numeroCategoria:number;
    }
}